function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#DADCDF",
  cx: "9",
  cy: "9",
  r: "9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.505 3.505a.7.7 0 01.99 0l.793.794L13 4.3a.7.7 0 01.694.605L13.7 5v8a.7.7 0 01-.7.7H5a.7.7 0 01-.7-.7V5a.7.7 0 01.7-.7l2.711-.001zM9 4L8 5H5v8h8V5h-3L9 4zm.01 5.019c1.11 0 2.01.996 2.01 2.217a.228.228 0 01-.457 0c0-.973-.699-1.761-1.553-1.761-.855 0-1.554.788-1.554 1.76a.228.228 0 01-.456 0c0-1.22.9-2.216 2.01-2.216zM9.005 6.5a1.119 1.119 0 110 2.238 1.119 1.119 0 010-2.238zm0 .456a.663.663 0 10.001 1.327.663.663 0 000-1.327z",
  fill: "#FFF"
}))));